<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {RelationFilter} from "@/types/Wiser/relation.ts";
import RelationFilterForm from "@/views/Wiser/RelationFilterForm.vue";
const modelFilter = ref<RelationFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <RelationFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-relation" model="Relation" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
